import { CloudDownload } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCloudDownload = mkIcon(CloudDownload);
